import { parseQuery, mapKeys, KEEN_KEY } from '@keen.io/parser';
export var prepareVisualization = function (input, keysMap, componentSettings, type, presentationTimezone) {
    if (input === void 0) { input = {}; }
    var parser = parseQuery(input, type, presentationTimezone);
    var keys = parser.keys;
    var results = parser.data;
    if (keysMap) {
        var labelSelector = 'labelSelector' in componentSettings
            ? componentSettings.labelSelector
            : KEEN_KEY;
        var mappings = mapKeys(keysMap, keys, results, labelSelector);
        keys = mappings.keys;
        results = mappings.results;
    }
    return {
        keys: keys,
        results: results,
    };
};
